<template>
  <v-card flat>
    <v-list-item>
      <v-list-item-content two-line class="pt-0">
        <v-list-item-title class="headline">{{
          $t('personnePhysique.remplacerContact.title')
        }}</v-list-item-title>
        <v-list-item-subtitle
          >Choisisez un contact à remplacer/rajouter dans les
          instances.</v-list-item-subtitle
        >
      </v-list-item-content>
    </v-list-item>
    <v-card-text>
      <dialogRecherchePersonnePhysique
        ref="dialogSource"
        subtitle="Recherche un contact à remplacer"
        @input="selectionSource"
      />
      <dialogRecherchePersonnePhysique
        ref="dialogRemplacant"
        subtitle="Recherche un contact remplaçant"
        @input="selectionRemplacant"
      />

      <v-stepper v-model="step" vertical>
        <v-stepper-step step="1" :complete="!!source">
          Sélectionner un contact source
          <strong v-if="source">{{ source.nom }} {{ source.prenoms }}</strong>
        </v-stepper-step>

        <v-stepper-content step="1">
          <v-btn
            color="primary"
            @click="afficheSource"
            :disabled="chargementInstance"
          >
            sélectionner un contact
          </v-btn>
        </v-stepper-content>

        <v-stepper-step
          step="2"
          :complete="instancesVerified"
          :rules="[() => !aucuneInstances]"
        >
          <div>
            Vérifier les instances du contact source
            <v-progress-circular
              :size="20"
              v-if="chargementInstance"
              indeterminate
              color="primary"
            ></v-progress-circular>
          </div>
          <strong v-if="aucuneInstances"
            >Le contact sélectionné ne participe à aucune instance.</strong
          >
        </v-stepper-step>

        <v-stepper-content step="2">
          <template v-if="instances.length">
            <listInstancesContact flat :instances="instances" />

            <v-btn color="primary" @click="verificationInstances">
              Continuer
            </v-btn>
          </template>
          <v-btn text @click="annuler">
            Annuler
          </v-btn>
        </v-stepper-content>

        <v-stepper-step step="3" :complete="!!remplacant">
          Sélectionner un contact remplaçant
          <strong v-if="remplacant"
            >{{ remplacant.nom }} {{ remplacant.prenoms }}</strong
          >
        </v-stepper-step>

        <v-stepper-content step="3">
          <v-btn color="primary" @click="afficheRemplacant">
            sélectionner un remplaçant
          </v-btn>
          <v-btn text @click="annuler">
            Annuler
          </v-btn>
        </v-stepper-content>

        <v-stepper-step step="4">
          Finaliser le remplacement
        </v-stepper-step>

        <v-stepper-content step="4">
          <p>
            Veuillez sélection le mode de remplacement :
          </p>
          <v-radio-group v-model="remplacer">
            <v-radio label="Remplacer le contact" :value="true"></v-radio>
            <v-radio
              label="Rajouter le contact dans toutes les instances"
              :value="false"
            ></v-radio>
          </v-radio-group>

          <p>
            Vous allez
            <template v-if="remplacer"
              >remplacer le contact
              <strong v-if="source"
                >{{ source.nom }} {{ source.prenoms }}</strong
              >
              par
              <strong v-if="remplacant"
                >{{ remplacant.nom }} {{ remplacant.prenoms }}</strong
              >

              dans toutes ses {{ instances.length }} instances ?
            </template>
            <template v-else
              >rajouter le contact
              <strong v-if="remplacant"
                >{{ remplacant.nom }} {{ remplacant.prenoms }}</strong
              >
              aux {{ instances.length }} instances auxquelles
              <strong v-if="source"
                >{{ source.nom }} {{ source.prenoms }}</strong
              >
              participe ?
            </template>
          </p>

          <v-btn
            color="primary"
            @click="validerRemplacement"
            :loading="validationRemplacement"
          >
            Valider
          </v-btn>
          <v-btn text @click="annuler"> Annuler </v-btn>
        </v-stepper-content>
      </v-stepper>
    </v-card-text>
  </v-card>
</template>

<script>
import toasted from '@/utils/toasted';
export default {
  data() {
    return {
      source: null,
      remplacant: null,
      remplacer: true,
      instances: [],
      chargementInstance: false,
      validationRemplacement: false,
      step: 1,
    };
  },
  computed: {
    instancesVerified() {
      return this.step > 2;
    },
    aucuneInstances() {
      return (
        this.step === 2 &&
        this.instances.length === 0 &&
        !this.chargementInstance
      );
    },
  },
  methods: {
    annuler() {
      this.source = null;
      this.remplacant = null;
      this.instances = [];
      this.step = 1;
    },
    afficheSource() {
      this.$refs.dialogSource.show();
    },
    afficheRemplacant() {
      this.$refs.dialogRemplacant.show();
    },
    verificationInstances() {
      this.step = 3;
    },
    selectionSource(input) {
      this.source = input;
      //recherche d'instance dun contact
      this.chargementInstance = true;
      this.$api(`/instance/contact/${input.id}`)
        .get()
        .then(response => {
          this.instances = response.body;
          this.step = 2;
        })
        .finally(() => (this.chargementInstance = false));
    },
    selectionRemplacant(input) {
      this.step = 4;
      this.remplacant = input;
    },
    validerRemplacement() {
      this.validationRemplacement = true;
      this.$api(`//contact/${this.source.id}/remplacer/${this.remplacant.id}`)
        .post({
          remplacer: this.remplacer,
        })
        .then(() => {
          toasted.info('personnePhysique.remplacerContact.done');
          this.annuler();
        })
        .finally(() => (this.validationRemplacement = false));
    },
  },
};
</script>
